import { SentryErrorComponent } from '@components/Fallback'
import BasePage from '@components/Layouts/BasePage'
import { ManageSelectedOrgProvider } from '@features/organisations/contexts/ManageSelectedOrg'
import { PermissionsCheckerProvider } from '@lib/permissions'
import {
  createFileRoute,
  Outlet,
  useLocation,
  useRouterState,
} from '@tanstack/react-router'

const StaffRoute = () => {
  const matches = useRouterState({ select: (s) => s.matches })
  const location = useLocation()
  const matchWithTitle = [...matches].reverse().find((d) => d.context.getTitle)
  const title = matchWithTitle?.context.getTitle() || 'Cloudmix'

  const breadcrumbs = matches
    .filter((match) => match.loaderData?.crumb)
    .map(({ pathname, loaderData }) => ({
      title: loaderData?.crumb,
      path: pathname,
      isCurrentPage: pathname === location.pathname,
    }))

  return (
    <ManageSelectedOrgProvider>
      <PermissionsCheckerProvider>
        <BasePage title={title} breadcrumbs={breadcrumbs}>
          <Outlet />
        </BasePage>
      </PermissionsCheckerProvider>
    </ManageSelectedOrgProvider>
  )
}

export const Route = createFileRoute('/_auth/staff')({
  component: StaffRoute,
  errorComponent: SentryErrorComponent,
})
